import { createPortal } from "react-dom";
import { BoltGrid, fmt } from "./RatePrint";

const exact = { WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" };

export function RatePrint88({ rows, basic, date }) {
  const d = date ? new Date(date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "";

  return createPortal(
    <div id="print-area" style={{ fontFamily: "Arial, Helvetica, sans-serif", color: "#000" }}>
      <div style={{ position: "relative", height: "297mm", padding: "12mm 11mm", boxSizing: "border-box", display: "flex", flexDirection: "column", overflow: "hidden" }}>
        {/* watermark */}
        <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none", zIndex: 0 }}>
          <div style={{ fontSize: "150px", fontWeight: 900, color: "#0f172a", opacity: 0.05, transform: "rotate(-28deg)", whiteSpace: "nowrap", letterSpacing: "0.08em", ...exact }}>
            TRB 8.8
          </div>
        </div>

        {/* content above watermark */}
        <div style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", height: "100%" }}>
          {/* header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "3px solid #000", paddingBottom: "8px" }}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: "14px" }}>
              <img src="/trb-88-logo.png" alt="TRB 8.8" style={{ height: "78px", width: "78px", objectFit: "contain", ...exact }} />
              <div style={{ fontSize: "13px", lineHeight: 1.35 }}>
                <div style={{ fontWeight: 900, fontSize: "19px" }}>TR BOLT HOUSE <span style={{ fontWeight: 400, fontSize: "12px" }}>03BQTPG2220A1ZK</span></div>
                <div>Plot No B29-2, Near Ravi Kanda Sua Road, Industrial Area C, LUDHIANA 141003</div>
                <div style={{ fontWeight: 900, fontSize: "19px", marginTop: "5px" }}>TR ENTERPRISES <span style={{ fontWeight: 400, fontSize: "12px" }}>03AARPG1533H2ZZ</span></div>
                <div>Shop No. 857, Tagore Colony, New Cycle Market, Gill Road, LUDHIANA 141003</div>
                <div style={{ marginTop: "5px" }}>Ph (O): +91 98780-91782 &nbsp;Ishan Gupta &nbsp;|&nbsp; +91 98728-68722 &nbsp;Naveen Gupta</div>
              </div>
            </div>
            <div style={{ textAlign: "right", fontSize: "16px" }}>
              <div style={{ fontWeight: 700 }}>Date: {d}</div>
              <div style={{ marginTop: "6px", padding: "6px 12px", border: "2px solid #0f172a", borderRadius: "6px", background: "#f1f5f9", ...exact }}>
                Basic Rate (8.8): <b style={{ fontSize: "19px" }}>₹{fmt(basic)}</b> / kg
              </div>
            </div>
          </div>

          {/* titles */}
          <div style={{ textAlign: "center", fontSize: "30px", fontWeight: 900, letterSpacing: "0.03em", marginTop: "8px" }}>
            TR BOLT RATE LIST
          </div>
          <div style={{ textAlign: "center", fontSize: "18px", fontWeight: 800, letterSpacing: "0.05em", marginTop: "2px", color: "#0f172a" }}>
            GRADE 8.8 · HIGH TENSILE (METRIC)
          </div>
          <div style={{ textAlign: "center", fontSize: "15px", fontWeight: 700, margin: "3px 0 8px", color: "#0369a1" }}>
            ALL RATES IN ₹ PER KG
          </div>

          {/* grid */}
          <BoltGrid title="HEX BOLT — LENGTH (IN METRICS) — 8.8" rows={rows} cat="metric" perKg big />

          {/* material spec */}
          <div style={{ marginTop: "12px", fontSize: "13px", fontWeight: 600, padding: "9px 12px", border: "1px solid #94a3b8", borderRadius: "6px", background: "#f8fafc", lineHeight: 1.5, ...exact }}>
            <b>Material Specification:</b> Grade 8.8 High Tensile Hex Bolts — conforming to IS 1367 / ISO 898-1, Property Class 8.8. HSN 7318.
            <div style={{ marginTop: "3px" }}>Bolts are <b>tempered and plated</b> — plating can be <b>Zinc</b> or <b>Auto Black</b>.</div>
            <div style={{ marginTop: "3px" }}><b>Test Certificate will be provided.</b></div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
